import { Tooltip } from "react-tooltip";

const TooltipHelper = ({
  id,
  className,
  wrapper,
  place,
  scrollHide,
  multiline,
}: any) => {
  
  const isTabletDevice = navigator.maxTouchPoints > 0 

  function handleTooltipAfterShow() {
    if (isTabletDevice) {
    //   setTimeout(Tooltip.delayHide, 2000);
    }
  }

  return (
    <Tooltip
      id={id}
      afterShow={handleTooltipAfterShow}
      className={`bg-primary rounded-lg ${className || ""}`}
      wrapper={wrapper}
      place={place}
      float={true}
      closeOnScroll={scrollHide}
    //   multiline={multiline}
    />
  );
};

export default TooltipHelper;
